import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Button,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroupAddon,
  Tooltip,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import useFormValidation from "../hooks/useFormValidation";
import { addQuesionValidationConfig } from "../config/form-validation/addFormValidation";
import { fetchServices, submitQuestion } from "../http/http-calls";
import { showToast } from "../helper-methods";
import { InputGroup } from "react-bootstrap";
import VerificationCaptcha from "./VerificationCaptcha";
import { hamiltonZipcodeConfig } from "../config/hamilton-zipcode-config";
// import Swal from "sweetalert2";
import ReactSelect from "react-select";

const ApplicationFormComponent = ({ viewApplicationData }) => {
  const childRef = useRef(); //for capcha in child componenet
  const history = useHistory();
  const [flag, setFlag] = useState(false);
  const [isToken, setIsToken] = useState("");
  const [editDetails, setEditDetails] = useState({});

  const [hideIDVA, setIDVA] = useState("true");

  const _toggleIDVA = () => setIDVA(!hideIDVA);

  const [tooltipOpen, setTooltipOpen] = useState([false, false]);
  const [serviceList, setServiceList] = useState([]);

  const _toggle = (i) => {
    const newArray = tooltipOpen.map((each, index) => {
      return index === i ? !each : false;
    });
    setTooltipOpen(newArray);
  };

  const {
    firstName,
    lastName,
    email,
    phone,
    zipcode,
    bestTime,
    question,
    preferredCommunication,
    service,
  } = editDetails || {};

  const initialFormValues = useMemo(() => {
    return {
      firstName: firstName || viewApplicationData?._resident?.name?.first || "",
      lastName: lastName || viewApplicationData?._resident?.name?.last || "",
      email: email || viewApplicationData?._resident?.email || "",
      phone: phone || viewApplicationData?._resident?.phone || "",
      zipcode: zipcode || viewApplicationData?.zipcode || "",
      bestTime: bestTime || viewApplicationData?.bestTime || "",
      question: question || viewApplicationData?.question || "",
      preferredCommunication:
        preferredCommunication ||
        viewApplicationData?.preferredCommunication ||
        "all",
      service: service || viewApplicationData?.service || [],
    };
  }, [
    firstName,
    viewApplicationData?._resident?.name?.first,
    viewApplicationData?._resident?.name?.last,
    viewApplicationData?._resident?.email,
    viewApplicationData?._resident?.phone,
    viewApplicationData?.zipcode,
    viewApplicationData?.bestTime,
    viewApplicationData?.question,
    viewApplicationData?.preferredCommunication,
    viewApplicationData?.service,
    lastName,
    email,
    phone,
    zipcode,
    bestTime,
    question,
    preferredCommunication,
    service,
  ]);

  const {
    formErrors,
    formValues,
    handleInputBlur,
    handleInputChange,
    handleSubmit,
    setFormValues,
    setFormErrors,
    handleChipBlur,
    handleServiceChange,
  } = useFormValidation(
    initialFormValues,
    _onSubmit,
    addQuesionValidationConfig
  );

  const _clearFieldValue = () => {
    setFormValues({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      countyCode: "",
      zipcode: "",
      bestTime: "",
      question: "",
    });
    setFormErrors({});
    history.push("/home");
  };

  async function _onSubmit(values) {
    try {
      let capchValidation;
      if (!isToken?.length) {
        capchValidation = childRef.current.doSubmit();
        if (!capchValidation) {
          return;
        }
      }

      setFlag(true);
      const payload = {
        ...values,
        name: {
          first: values.firstName,
          last: values.lastName,
        },
      };
      delete payload.firstName;
      delete payload.lastName;

      let res;

      console.log("isToken?.length", isToken?.length);

      if (!isToken?.length) {
        res = await submitQuestion(payload);
      } else {
        //  res = await updateProvider(payload);
      }
      if (!res?.error) {
        showToast(
          isToken?.length
            ? "Provider Updated Successfully!"
            : "Application Submitted Successfully!",
          "success"
        );
      }
      _toggleIDVA();
    } catch (error) {
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    } finally {
      setFlag(false);
    }
  }

  const _addProviderHandler = (e) => {
    handleSubmit(e, formValues);
  };

  const _fetchAllServices = async () => {
    try {
      const res = await fetchServices();
      console.log("allservices", res);
      setServiceList(
        res?.data?.map((each) => {
          return {
            id: each?._id,
            label: each?.serviceName,
            value: each?.serviceName,
          };
        })
      );
    } catch (error) {
      console.log("error", error);
      showToast(
        error.reason && error.reason.length
          ? error.reason
          : "Server error. Try again after sometime.",
        "error"
      );
    }
  };
  useEffect(() => {
    _fetchAllServices();
  }, []);

  useEffect(() => {
    let token = sessionStorage.getItem("token");
    if (token) {
      setIsToken(token);
      setEditDetails(viewApplicationData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={!hideIDVA ? "d-none" : ""}>
        <Row className="justify-content-center" noGutters>
          <Col xl="6" lg="8" md="10">
            <Card className="p-0 p-sm-3">
              <CardHeader>
                <CardTitle className="fs-22 text-theme fw-bold text-center">
                  {/* {!isToken?.length ? "New" : "View"} Application Form */}
                  Connect To A Navigator
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <Label>First Name</Label>
                        <Input
                          type="text"
                          placeholder="First Name"
                          autoComplete="off"
                          name="firstName"
                          value={formValues?.firstName}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {formErrors?.firstName ? (
                          <div className="form-error">
                            {formErrors?.firstName}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <Label>Last Name</Label>
                        <Input
                          type="text"
                          placeholder="Last Name"
                          autoComplete="off"
                          name="lastName"
                          value={formValues?.lastName}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                        />
                        {formErrors?.lastName ? (
                          <div className="form-error">
                            {formErrors?.lastName}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label>Preferred Communication method</Label>
                    <div className="radio-group">
                      <FormGroup check>
                        <Input
                          type="radio"
                          value="email"
                          checked={
                            formValues?.preferredCommunication === "email"
                          }
                          onChange={handleInputChange}
                          name="preferredCommunication"
                          id="preferredCommunication1"
                        />
                        <Label check for="preferredCommunication1">
                          Email
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          type="radio"
                          value="call"
                          checked={
                            formValues?.preferredCommunication === "call"
                          }
                          onChange={handleInputChange}
                          name="preferredCommunication"
                          id="preferredCommunication2"
                        />
                        <Label check for="preferredCommunication2">
                          Call
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          type="radio"
                          value="text"
                          checked={
                            formValues?.preferredCommunication === "text"
                          }
                          onChange={handleInputChange}
                          name="preferredCommunication"
                          id="preferredCommunication3"
                        />
                        <Label check for="preferredCommunication3">
                          Text
                        </Label>
                      </FormGroup>
                      <FormGroup check>
                        <Input
                          type="radio"
                          value="all"
                          checked={formValues?.preferredCommunication === "all"}
                          onChange={handleInputChange}
                          name="preferredCommunication"
                          id="preferredCommunication4"
                        />
                        <Label check for="preferredCommunication4">
                          All
                        </Label>
                      </FormGroup>
                    </div>
                    {formErrors?.preferredCommunication ? (
                      <div className="form-error">
                        {formErrors?.preferredCommunication}
                      </div>
                    ) : null}
                  </FormGroup>

                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      placeholder="Email"
                      autoComplete="off"
                      name="email"
                      value={formValues?.email}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                    />
                    {formErrors?.email ? (
                      <div className="form-error">{formErrors?.email}</div>
                    ) : null}
                  </FormGroup>

                  <FormGroup>
                    <Label>Phone</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <Input
                          type="select"
                          placeholder="Enter"
                          value="+1"
                          disabled
                          style={{
                            minWidth: "70px",
                            maxWidth: "90px",
                          }}
                        >
                          <option value="+1">+1</option>
                        </Input>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        placeholder="Phone Number"
                        autoComplete="off"
                        name="phone"
                        value={formValues?.phone}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                      />
                    </InputGroup>

                    {formErrors?.phone ? (
                      <div className="form-error">{formErrors?.phone}</div>
                    ) : null}
                  </FormGroup>
                  <Row>
                    <Col lg="6">
                      <FormGroup>
                        <Label>Best Time For Contact</Label>
                        <Input
                          type="select"
                          value={formValues?.bestTime}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                          name="bestTime"
                        >
                          <option value="">-- Select --</option>
                          <option value="morning">Morning</option>
                          <option value="afternoon">Afternoon</option>
                          <option value="evening">Evening</option>
                        </Input>
                        {formErrors?.bestTime ? (
                          <div className="form-error">
                            {formErrors?.bestTime}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                    <Col lg="6">
                      <FormGroup>
                        <Label>ZIP Code</Label>
                        <Input
                          type="select"
                          value={formValues?.zipcode}
                          onChange={handleInputChange}
                          onBlur={handleInputBlur}
                          name="zipcode"
                        >
                          <option value="">-- Select --</option>
                          {hamiltonZipcodeConfig.map((item, index) => (
                            <option key={index} value={item.postalCode}>
                              {item.name} ({item.postalCode})
                            </option>
                          ))}
                        </Input>
                        {formErrors?.zipcode ? (
                          <div className="form-error">
                            {formErrors?.zipcode}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup className="mb-0 mr-2 mt-3">
                    <Label className="d-flex align-items-center">
                      {/* Select the Service or Services You Provide */}
                      Select all that apply and/or put your specific need in the
                      box below
                      <i
                        className="fa fa-info-circle ml-1"
                        id="service_strong_veteran_page"
                      />
                      <Tooltip
                        autohide={false}
                        placement="right"
                        isOpen={tooltipOpen[1]}
                        target="service_strong_veteran_page"
                        toggle={() => _toggle(1)}
                      >
                        Services!
                      </Tooltip>
                    </Label>
                    <div className="react-select">
                      <ReactSelect
                        isSearchable={true}
                        closeMenuOnSelect={false}
                        name="service"
                        isMulti
                        className="react-select-container"
                        classNamePrefix="react-select"
                        options={serviceList}
                        onChange={handleServiceChange}
                        onBlur={() => handleChipBlur("service")}
                        placeholder="Select all that apply"
                      />
                    </div>
                    {formErrors.service ? (
                      <div className="form-error">{formErrors.service}</div>
                    ) : null}
                  </FormGroup>

                  <FormGroup>
                    <Label>What are your questions/needs?</Label>
                    <Input
                      type="textarea"
                      value={formValues?.question}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      name="question"
                    />
                    {formErrors?.question ? (
                      <div className="form-error">{formErrors?.question}</div>
                    ) : null}
                  </FormGroup>

                  {/* captcha */}
                  {isToken?.length ? null : (
                    <VerificationCaptcha ref={childRef} />
                  )}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {isToken?.length ? null : (
          <div className="submitWrapper">
            {/* {isToken?.length ? null : ( */}
            <Button color="secondary" onClick={() => _clearFieldValue()}>
              Cancel
            </Button>
            {/* )} */}

            <Button
              color="primary"
              onClick={_addProviderHandler}
              disabled={
                //   JSON.stringify(prevData) === JSON.stringify(formData) ||
                flag === true
              }
            >
              {isToken?.length ? "Update" : "Submit"}
            </Button>
          </div>
        )}
      </div>
      <div className={` ${hideIDVA ? "d-none " : ""} success_message_stronger`}>
        <h1 style={{ fontSize: "40px" }}>SUCCESS</h1>
        <p>
          You will be contacted by the navigator within 24 hours via phone or
          email or text.
        </p>
        {/* <p className="mt-3 fw-bold">Average response time: 24-72hrs </p> */}
        <ul className="socialMedia">
          <li>
            <a
              className="facebook"
              target="_blank"
              href="https://www.facebook.com/indiana.veterans/"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a>
          </li>
          <li>
            <a
              className="twitter"
              target="_blank"
              href="https://twitter.com/InVetAffairs/"
              rel="noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </li>
          <li>
            <a
              className="instagram"
              target="_blank"
              href="https://www.instagram.com/in_dva/"
              rel="noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </li>
          <li>
            <a
              className="linkedin"
              target="_blank"
              href="https://www.linkedin.com/company/indiana-department-of-veterans-affairs/"
              rel="noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
          </li>
          <li>
            <a
              className="youtube"
              target="_blank"
              href="https://www.youtube.com/channel/UCkWjgqICyheTJDDr-GzRs9Q"
              rel="noreferrer"
            >
              <i className="fab fa-youtube"></i>
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ApplicationFormComponent;
